import { useSearchParams } from "react-router-dom";

export const useConfigMode = () => {
    const [searchParams] = useSearchParams();

    return searchParams.has("config");
}